import { AppShell } from '@/components/shell/AppShell';
import { APP_NAV, type NavSection } from '@/components/shell/nav-config';
import { RequireAuth } from '@/features/auth/auth-guard';
import { useSession } from '@/features/auth/auth-store';
import { createFileRoute } from '@tanstack/react-router';
import { useMemo } from 'react';

export const Route = createFileRoute('/app')({
  component: AppLayout,
});

function AppLayout() {
  return (
    <RequireAuth>
      <ScopedAppShell />
    </RequireAuth>
  );
}

function ScopedAppShell() {
  const session = useSession();
  const role = session?.activeOrg.role;

  const sections = useMemo<NavSection[]>(() => {
    if (role !== 'member') return APP_NAV;
    return APP_NAV.map((section) => ({
      ...section,
      links: section.links.filter((link) => !link.privilegedOnly),
    })).filter((section) => section.links.length > 0);
  }, [role]);

  return <AppShell sections={sections} />;
}
